import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-base text-background-50"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-foreground-900">
                BaseTao Spreadsheet
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              This website provides independent research, guides, comparisons, and educational resources about BaseTao Spreadsheet. We are not affiliated with the official BaseTao platform.
            </p>
            <div className="flex items-center gap-2 mt-4">
              <div className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
                <i className="ri-shield-check-line"></i>
                <span>Independent Research</span>
              </div>
              <div className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium">
                <i className="ri-information-line"></i>
                <span>Educational Resource</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3 uppercase tracking-wider">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors">Home</Link>
              <Link to="/articles/basetao-spreadsheet-guide" className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors">Beginner Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors">BaseTao Spreadsheet</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3 uppercase tracking-wider">Popular Categories</h4>
            <div className="space-y-2">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors">Shoes</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors">Hoodies &amp; Sweaters</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors">T-Shirts</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors">Jackets</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} BaseTao Spreadsheet Research Hub. All rights reserved. This is an independent educational resource.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Terms of Use</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}